/* SC Desktop Menu bird search (990px and up). Loaded before sc-desktop-menu.js.
   Same species list and matching as the Bird Match Quiz (assets/bird-data.json, loads on first focus). */
(function () {
  'use strict';
  var dm = window.scDm = window.scDm || {};

  /* ---------- Bird search: same list and matching as the Bird Match Quiz (assets/bird-data.json) ---------- */
  var BIRD_BROAD = ['macaw', 'cockatoo', 'parrot', 'finch', 'corella', 'pigeon', 'rosella'];
  var BIRD_SMALL_MAX_G = 250;
  var BIRD_TOO_LARGE_G = 2500;
  var birdData = null;
  function loadBirds(src) {
    if (!birdData) {
      birdData = fetch(src, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('bird data ' + r.status); return r.json(); })
        .then(function (d) {
          var rev = {};
          for (var al in d.aliases || {}) {
            if (Object.prototype.hasOwnProperty.call(d.aliases, al)) (rev[d.aliases[al]] = rev[d.aliases[al]] || []).push(al);
          }
          d.rev = rev;
          return d;
        });
      birdData.catch(function () { birdData = null; });
    }
    return birdData;
  }
  /* Built from char codes: the theme file API turns backslash-u escapes into raw characters */
  var RE_MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  var RE_APOS = new RegExp('[' + String.fromCharCode(0x2019) + "']", 'g');
  function birdNorm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(RE_MARKS, '').replace(RE_APOS, '').replace(/[^a-z0-9& -]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function birdTitle(s) {
    return String(s || '').replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/\s(And|Of|The)\s/g, function (m) { return m.toLowerCase(); });
  }
  function birdPlural(s) {
    if (/(s|x|ch|sh)$/i.test(s)) return s + 'es';
    if (/[^aeiou]y$/i.test(s)) return s.slice(0, -1) + 'ies';
    return s + 's';
  }
  function birdBroad(d, q) {
    var n = birdNorm(q);
    if (!n) return '';
    var a = (d.aliases || {})[n] || n;
    if (BIRD_BROAD.indexOf(a) >= 0 && d.suggestions && d.suggestions[a]) return a;
    if (n.slice(-1) === 's') {
      var sing = (d.aliases || {})[n.slice(0, -1)] || n.slice(0, -1);
      if (BIRD_BROAD.indexOf(sing) >= 0 && d.suggestions && d.suggestions[sing]) return sing;
    }
    return '';
  }
  function birdFind(d, q) {
    var n = birdNorm(q);
    if (n.length < 2) return [];
    var toks = n.split(' ');
    var out = [];
    Object.keys(d.species).forEach(function (k) {
      if (BIRD_BROAD.indexOf(k) >= 0) return;
      var kn = birdNorm(k);
      var hit = toks.every(function (tk) { return kn.indexOf(tk) >= 0; });
      var viaAlias = '';
      if (!hit) {
        var als = d.rev[k] || [];
        for (var i = 0; i < als.length; i++) {
          if (toks.every(function (tk) { return als[i].indexOf(tk) >= 0; })) { hit = true; viaAlias = als[i]; break; }
        }
      }
      if (!hit) return;
      var score = kn.indexOf(n) === 0 ? 0 : (kn.indexOf(' ' + n) >= 0 || kn.indexOf('-' + n) >= 0) ? 1 : kn.indexOf(n) > 0 ? 2 : (viaAlias ? 3 : 2.5);
      out.push({ key: k, score: score, alias: viaAlias });
    });
    out.sort(function (a, b) { return a.score - b.score || a.key.localeCompare(b.key); });
    return out.slice(0, 6);
  }
  function quizLink(base, key, bq) {
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + (key ? 'species_breed=' + encodeURIComponent(key) + '&' : '') + 'bq=' + bq;
  }
  function initFind(box) {
    if (box.__dmFind) return;
    box.__dmFind = true;
    var q = box.querySelector('[data-dm-find-q]');
    var list = box.querySelector('[data-dm-find-list]');
    var st = box.querySelector('[data-dm-find-st]');
    var clear = box.querySelector('[data-dm-find-clear]');
    if (!q || !list) return;
    var src = box.getAttribute('data-src');
    var quiz = box.getAttribute('data-quiz') || '/pages/quiz';
    var txt = function (k, d) { return box.getAttribute('data-' + k) || d; };
    var seq = 0;

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function option(href, type, name, title, sub, pill) {
      var li = el('li');
      var a = el('a');
      a.href = href;
      a.setAttribute('data-dm-item', '');
      a.setAttribute('data-dm-type', type);
      a.setAttribute('data-dm-name', name);
      if (type === 'bird_search') a.setAttribute('data-dm-key', name);
      var t = el('span', 'sc-dm-res__t');
      t.appendChild(el('b', '', title));
      if (sub) t.appendChild(el('small', '', sub));
      a.appendChild(t);
      if (pill) a.appendChild(el('span', 'sc-dm-res__s', pill));
      li.appendChild(a);
      return li;
    }
    function sizeText(d, key) {
      var w = d.species[key];
      if (typeof w !== 'number') return '';
      if (w > BIRD_TOO_LARGE_G) return txt('xl', 'Very large bird: check fit');
      return w < BIRD_SMALL_MAX_G ? txt('small', 'Small Seed Cube') : txt('large', 'Large Seed Cube');
    }
    function status(msg) { if (st) st.textContent = msg; }
    function show(nodes) {
      list.textContent = '';
      nodes.forEach(function (n) { list.appendChild(n); });
      list.hidden = !nodes.length;
    }
    function noneLink(term) {
      return option(quizLink(quiz, '', 'desk_search_none'), 'bird_search_none', term.slice(0, 40), txt('none', 'Not on our list? Take the quiz'), '', '');
    }
    function render() {
      var term = q.value;
      if (clear) clear.hidden = !term;
      if (birdNorm(term).length < 2) { show([]); status(''); return; }
      var mine = ++seq;
      loadBirds(src).then(function (d) {
        if (mine !== seq) return;
        var nodes = [];
        var bk = birdBroad(d, term);
        if (bk) {
          var kinds = (d.suggestions[bk] || []).length;
          nodes.push(option(quizLink(quiz, bk, 'desk_search'), 'bird_search', bk, birdTitle(birdPlural(bk)), txt('kinds', '{n} kinds. Pick yours').replace('{n}', kinds), ''));
        }
        birdFind(d, term).forEach(function (m) {
          if (m.key === bk) return;
          nodes.push(option(quizLink(quiz, m.key, 'desk_search'), 'bird_search', m.key, birdTitle(m.key), m.alias ? 'Also called ' + birdTitle(m.alias) : '', sizeText(d, m.key)));
        });
        if (!nodes.length) { show([noneLink(term)]); status(txt('none', 'Not on our list? Take the quiz')); return; }
        show(nodes);
        status(nodes.length + (nodes.length === 1 ? ' match' : ' matches'));
      }, function () {
        if (mine !== seq) return;
        show([noneLink(term)]);
        status('');
      });
    }
    function links() { return Array.prototype.slice.call(list.querySelectorAll('a')); }

    q.addEventListener('focus', function () { loadBirds(src).catch(function () {}); });
    q.addEventListener('input', render);
    q.addEventListener('keydown', function (e) {
      var ls = links();
      if (e.key === 'ArrowDown' && ls.length) { e.preventDefault(); ls[0].focus(); }
      else if (e.key === 'Enter') { e.preventDefault(); if (ls.length) ls[0].click(); }
      else if (e.key === 'Escape' && q.value) { e.preventDefault(); e.stopPropagation(); q.value = ''; render(); }
    });
    list.addEventListener('keydown', function (e) {
      var ls = links();
      var i = ls.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); (ls[i + 1] || ls[i]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) q.focus(); else ls[i - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); q.focus(); }
    });
    if (clear) clear.addEventListener('click', function () { q.value = ''; render(); q.focus(); });
  }

  dm.initFind = initFind;
})();